export function decorateError(e, title, details) {
  const error = e.response?.data?.message ? new Error(e.response.data.message) : e;
  error.title = title;
  error.details = details;
  return error;
}

export function transformApiBooking(raw) {
  // Rename the bookingReference to id as that is what this site is build on.
  const { bookingReference, onlineBookingId, ...clone } = raw;
  clone.id = onlineBookingId.toLowerCase();
  clone.reference = bookingReference.toLowerCase();

  if (Array.isArray(clone.practitioners)) {
    clone.practitioners = clone.practitioners.map((practitioner) => ({
      ...practitioner,
      calendarSlots: practitioner.calendarSlots ?? practitioner.calendarListSlots ?? [],
    }));
  }

  if (clone.appointment) {
    clone.appointment = {
      ...clone.appointment,
      calendarListSlotId:
        clone.appointment.calendarListSlotId ?? clone.appointment.calendarSlotId ?? '',
    };
  }

  return clone;
}
